import { Button } from "react-bootstrap"
import toast from "react-hot-toast"

import { useAcceptJoinClubRequestMutation } from "../../app/clubsApiSlice"
import LoadingTextSwap from "../LoadingTextSwap"
import useAuth from "../../hooks/useAuth"
import { useClubNotificationsReadMutation } from "../../app/clubsApiSlice"

const AcceptJoinClubRequestButton = ({ requestId, clubId, setDisableButtons, disableButtons }) => {
  const { role } = useAuth()
  const [acceptJoinClubRequest] = useAcceptJoinClubRequestMutation()
  const [clubNotificationsRead] = useClubNotificationsReadMutation()

  const onButtonClick = async () => {
    try {
      setDisableButtons(true)
      await acceptJoinClubRequest({ requestId, role, clubId }).unwrap()
      clubNotificationsRead({ requests: [requestId], messages: [], clubId })
      toast.success("Request accepted")
      setDisableButtons(false)
    } catch (error) {
      console.error(error)

      if (error.data.message === "Request already declined") {
        toast.error("This request has already been declined either by the club secretary or the admin team")
      } else {
        toast.error("Error accepting request")
      }

      setDisableButtons(false)
    }
  }

  return (
    <Button disabled={disableButtons} variant="dark" className="shadow-btn rounded-3 w-50 fs-7" onClick={onButtonClick}>
      <LoadingTextSwap isLoading={disableButtons}>
        Accept
      </LoadingTextSwap>
    </Button>
  )
}

export default AcceptJoinClubRequestButton